/**
 * 問い合わせフォームの入力を打鍵時に半角へ寄せ、使えない文字を落とす。
 *
 * pattern は送信時にしか効かない。打っている最中は何でも入り、送信ボタンを
 * 押して初めて弾かれる。ここで先に直しておく。pattern は残してあり、
 * この処理が動かない環境では従来どおり送信時に弾かれる。
 *
 * **section の {% javascript %} ではなく独立したファイルにしている。**
 * あちらは読み込みの時機が公式ドキュメントで確認できず、要素より先に
 * 実行されると getElementById が null を返して何も起きない。
 *
 * **要素ではなく document で監視している。** 同じ理由で、要素の生成時機に
 * 依存しないようにするため。input / compositionstart / compositionend は
 * いずれも document まで伝播する。
 */
(function () {
  var RULES = {
    'ContactForm-email': /[^A-Za-z0-9@._+%!#$&'*\/=?^`{|}~-]/g,
    'ContactForm-phone': /[^0-9-]/g,
    'ContactForm-order-number': /[^0-9#]/g
  };

  var composingOn = null;

  /* 全角 ASCII（FF01-FF5E）をまとめて半角へ。全角スペースと、
     見た目の似たハイフン類も半角のハイフンへ寄せる。 */
  function toHalfWidth(value) {
    return value
      .replace(/[\uFF01-\uFF5E]/g, function (c) {
        return String.fromCharCode(c.charCodeAt(0) - 0xfee0);
      })
      .replace(/\u3000/g, ' ')
      .replace(/[\u2212\u30FC\u2010\u2011\u2013\u2014]/g, '-');
  }

  function clean(el) {
    var disallowed = RULES[el.id];
    if (!disallowed) return;

    var before = el.value;
    var after = toHalfWidth(before).replace(disallowed, '');
    if (after === before) return;

    /* type が email の入力欄は選択範囲の API に対応しておらず、
       selectionStart を読むだけで例外が出る。読み取りも包む。 */
    var caret = null;
    try {
      caret = el.selectionStart;
    } catch (e) {
      /* 扱えない type。カーソルは末尾へ寄る */
    }

    el.value = after;

    if (caret === null) return;
    var moved = caret - (before.length - after.length);
    try {
      el.setSelectionRange(moved, moved);
    } catch (e) {
      /* 同上 */
    }
  }

  /* 日本語変換の途中は触らない。変換中の文字列を書き換えると入力が壊れる。
     ただし「変換中かどうか」を全体で1つの真偽値として持つと、
     compositionend を取りこぼしたときに真のまま固まり、以後どの欄も
     整形されなくなる。**どの要素で変換中か**を持つ形にして、
     取りこぼしても他の欄へ波及しないようにする。 */
  document.addEventListener(
    'compositionstart',
    function (event) {
      if (RULES[event.target.id]) composingOn = event.target;
    },
    true
  );

  document.addEventListener(
    'compositionend',
    function (event) {
      if (composingOn === event.target) composingOn = null;
      if (RULES[event.target.id]) clean(event.target);
    },
    true
  );

  document.addEventListener(
    'input',
    function (event) {
      if (!RULES[event.target.id]) return;
      if (composingOn === event.target) return;
      clean(event.target);
    },
    true
  );

  /* 最後の砦。上の経路をすべて取りこぼしても、欄から離れた時点で必ず整形する。
     blur は伝播しないが、捕捉段階なら document で受け取れる。 */
  document.addEventListener(
    'blur',
    function (event) {
      if (composingOn === event.target) composingOn = null;
      if (RULES[event.target.id]) clean(event.target);
    },
    true
  );

  /* 種別が「領収書の発行」のときだけ、注文番号を必須にし、書き方の案内を出す。
     注文番号が無いと、どの注文の領収書か特定できないため。
     この処理が動かない環境では、注文番号は任意・案内は出ないままで、送信はできる。 */
  var RECEIPT_TYPE = '領収書の発行';

  function syncReceipt() {
    var type = document.getElementById('ContactForm-request-type');
    var orderNumber = document.getElementById('ContactForm-order-number');
    if (!type || !orderNumber) return;

    var on = type.value === RECEIPT_TYPE;
    orderNumber.required = on;
    orderNumber.setAttribute('aria-required', on ? 'true' : 'false');

    var targets = document.querySelectorAll('[data-hc-receipt-only]');
    for (var i = 0; i < targets.length; i++) {
      targets[i].hidden = !on;
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      if (event.target.id === 'ContactForm-request-type') syncReceipt();
    },
    true
  );

  /* 送信エラーで戻ったときや、ブラウザが選択を復元したときにも合わせる */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncReceipt);
  } else {
    syncReceipt();
  }
  window.addEventListener('pageshow', syncReceipt);
})();
